import Link from "next/link";

import ChevronRightIcon from "@repo/ui-system/icons/arrows/chevron-right/outline.svg";

import { DrawerClose } from "@/components/ui/drawer";
import { cn } from "@/lib/utils";

import type { Category } from "../categories";

type Props = {
  item: Category;
  onDrillDown: () => void;
  className?: string;
};

export function CategoryItem({ item, onDrillDown, className }: Props) {
  if (item.type === "leaf") {
    return (
      <DrawerClose asChild>
        <Link
          href={item.url}
          className={cn("block capitalize", className)}
        >
          {item.name}
        </Link>
      </DrawerClose>
    );
  }

  const hasUrl = !!item.url;

  return (
    <div className={cn("flex items-center justify-between w-full", className)}>
      {hasUrl ? (
        <DrawerClose asChild>
          <Link
            href={item.url!}
            className="capitalize"
          >
            {item.name}
          </Link>
        </DrawerClose>
      ) : (
        <button onClick={onDrillDown}>
          <span className="capitalize">{item.name}</span>
        </button>
      )}
      {item.children.length > 0 && (
        <button
          onClick={onDrillDown}
          className="p-2 -m-2"
          aria-label={`Open ${item.name} submenu`}
        >
          <ChevronRightIcon className="size-5" />
        </button>
      )}
    </div>
  );
}
